var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"host"},[_c('b-pagination',{attrs:{"value":_vm.value,"total-rows":_vm.length,"per-page":_vm.pageSize,"size":"sm"},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }